import type { GraphDocument } from '@/domain/funnel/graph-document';
import { FUNNEL_SCHEMA_VERSION } from '@/domain/funnel/schema-version';

export class UnsupportedGraphSchemaError extends Error {
  constructor(readonly schemaVersion: number) {
    super(`Graph schema version ${schemaVersion} is not supported.`);
  }
}

/** Canonical N→N+1 migration entry point. Version 1 is the first schema. */
export function migrateGraphDocumentCopy(graph: GraphDocument): GraphDocument {
  if (graph.schemaVersion !== FUNNEL_SCHEMA_VERSION) {
    throw new UnsupportedGraphSchemaError(graph.schemaVersion);
  }
  return structuredClone(graph);
}

